<template>
  <div class="flex mb-5 -space-x-4">
    <a-tooltip placement="top" v-for="player in this.players">
      <template #title>
        <span>{{ player.name }} ({{ player.email }})</span>
      </template>
      <img class="w-8 h-8 rounded-full border-2 border-white dark:border-gray-800"
           :src="player.profile_photo_path" alt="">
    </a-tooltip>
  </div>
</template>

<script>

export default {
  props: ['players'],
  name: "Players",
  created(){
  },
  setup() {
    return {}
  },
  data() {
    return {};
  },
  components: {},
};
</script>
